import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useCountryCode } from '#src/app/shared/hooks/l10n';

import { searchDecisionMakers } from './api/searchDecisionMakers';
import type { DecisionMaker } from './types';

type Result =
	| { readonly status: 'loading' }
	| { readonly status: 'error' }
	| { readonly status: 'loaded'; readonly data: readonly DecisionMaker[] };

export function useDecisionMakerSearch(input: string): Result {
	const countryCode = useCountryCode();
	const utilityContext = useUtilityContext();

	const { data, isPending, isError } = useQuery({
		queryKey: ['decision-makers-search', input, countryCode],
		queryFn: async () => searchDecisionMakers({ searchQuery: input, countryCode }, utilityContext),
		placeholderData: keepPreviousData,
	});

	if (isPending) return { status: 'loading' };
	if (isError) return { status: 'error' };
	return { status: 'loaded', data };
}
